<!-- eslint-disable vue/no-mutating-props -->
<template>
  <v-row class="ma-0" no-gutters>
    <v-col class="pr-md-4" cols="12" md="4">
      <v-card border>
        <v-card-text class="pa-5">
          <div class="d-flex justify-end mb-6">
            <div class="d-flex align-center gap-2">
              <span class="d-block font-size-13">
                {{ user.isActive ? 'Активний' : 'Звільнений' }}
              </span>
              <v-switch
                v-model="user.isActive"
                :readonly="readonly"
                color="success"
                density="comfortable"
                hide-details
                @update:model-value="handleActive">
              </v-switch>
            </div>
          </div>

          <div class="d-flex justify-center mb-6">
            <UserPhoto
              v-model="user.photo"
              :readonly="readonly"
              :user="user.$object" />
          </div>

          <v-divider class="mb-4" />

          <div class="d-flex justify-center align-center">
            <v-btn
              :class="{ 'cursor-not-allowed': readonly }"
              :readonly="readonly"
              class="px-0"
              color="blue-darken-3"
              variant="text"
              @click="toggleChangePassword">
              {{ changePassword ? 'Скасувати зміну пароля' : 'Змінити пароль' }}
            </v-btn>
          </div>

          <b-input
            v-if="changePassword && !readonly"
            v-model="user.password"
            class="mt-3"
            hide-details
            label="Новий пароль"
            type="password" />
        </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12" md="8">
      <div class="d-flex flex-column ga-5">
        <div>
          <v-chip
            class="mb-3"
            color="blue-lighten-5"
            density="comfortable"
            rounded="lg"
            size="small"
            variant="flat">
            <span class="font-weight-bold text-blue-darken-3">
              Співробітник
            </span>
          </v-chip>

          <v-row>
            <v-col cols="12" md="4">
              <b-input
                v-model="user.surname"
                :error-messages="getErrorMessages(v$.surname)"
                :readonly="readonly"
                hide-details
                label="Прізвище"
                @blur="v$.surname.$touch()" />
            </v-col>
            <v-col cols="12" md="4">
              <b-input
                v-model="user.name"
                :error-messages="getErrorMessages(v$.name)"
                :readonly="readonly"
                hide-details
                label="Ім'я"
                @blur="v$.name.$touch()" />
            </v-col>
            <v-col cols="12" md="4">
              <b-input
                v-model="user.patronymic"
                :error-messages="getErrorMessages(v$.patronymic)"
                :readonly="readonly"
                hide-details
                label="По батькові"
                @blur="v$.patronymic.$touch()" />
            </v-col>
            <v-col cols="12" md="6">
              <b-input
                :model-value="user.department?.name"
                hide-details
                label="Підрозділ"
                readonly />
            </v-col>
            <v-col cols="12" md="6">
              <b-input
                :model-value="user.position"
                hide-details
                label="Посада"
                readonly />
            </v-col>
            <v-col cols="12" md="6">
              <b-select
                v-model="user.workScheduleId"
                :items="$directory.get('workSchedules')"
                :readonly="readonly"
                hide-details
                label="Графік роботи"
                @focus="$directory.fill('workSchedules')" />
            </v-col>
            <v-col cols="12" md="6">
              <b-select
                v-model="user.workFormatId"
                :items="$directory.get('workFormats')"
                :readonly="readonly"
                hide-details
                label="Формат роботи"
                @focus="$directory.fill('workFormats')" />
            </v-col>
          </v-row>
        </div>

        <div>
          <v-chip
            class="mb-3"
            color="green-lighten-5"
            density="comfortable"
            rounded="lg"
            size="small"
            variant="flat">
            <span class="font-weight-bold text-green-darken-3">
              Особисті дані
            </span>
          </v-chip>

          <v-row>
            <v-col cols="12" md="4">
              <b-input
                v-model="user.inn"
                v-mask:[innMask]
                :error-messages="getErrorMessages(v$.inn)"
                :readonly="readonly"
                hide-details
                label="ІПН"
                type="mask"
                @blur="v$.inn.$touch()" />
            </v-col>
            <v-col cols="12" md="4">
              <b-select
                v-model="user.genderId"
                :error-messages="getErrorMessages(v$.genderId)"
                :items="$directory.get('genders')"
                :readonly="readonly"
                hide-details
                label="Стать"
                @blur="v$.genderId.$touch()"
                @focus="$directory.fill('genders')" />
            </v-col>
            <v-col cols="12" md="4">
              <b-input-date
                v-model="user.birthDate"
                :error-messages="getErrorMessages(v$.birthDate)"
                :readonly="readonly"
                hide-details
                label="Дата народження"
                @blur="v$.birthDate.$touch()"></b-input-date>
            </v-col>
          </v-row>
        </div>

        <div>
          <v-chip
            class="mb-3"
            color="deep-purple-lighten-5"
            density="comfortable"
            rounded="lg"
            size="small"
            variant="flat">
            <span class="font-weight-bold text-deep-purple-darken-3">
              Контакти
            </span>
          </v-chip>

          <v-row>
            <v-col cols="12" md="6">
              <b-input
                v-model="user.email"
                v-mask:[emailMask]
                :error-messages="getErrorMessages(v$.email)"
                :readonly="readonly"
                hide-details
                label="Пошта"
                @blur="v$.email.$touch()" />
            </v-col>
            <v-col cols="12" md="6">
              <b-input
                v-model="user.profileDWH"
                :error-messages="getErrorMessages(v$.profileDWH)"
                :readonly="readonly"
                hide-details
                label="ProfileDWH"
                @blur="v$.profileDWH.$touch()" />
            </v-col>
            <v-col cols="12" md="6">
              <b-input-phone
                v-model="user.phone"
                :error-messages="getErrorMessages(v$.phone)"
                :readonly="readonly"
                hide-details
                label="Телефон"
                @blur="v$.phone.$touch()"></b-input-phone>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { emailMask, innMask } from '@/utils/masks.js'
import { getErrorMessages } from '@/utils/helpers'
import { BInputDate, BInputPhone } from 'best-modules/components'
import UserPhoto from '@/dialog/components/user-card/UserPhoto.vue'
import { useUserCardStore } from '@/dialog/components/user-card/store'
import { useUserCardGeneralStore } from '@/dialog/components/user-card/tabs/general/general'
import { fillDirectory } from '@/directory/index.ts'

export default {
  name: 'UserCardGeneral',
  components: {
    UserPhoto,
    BInputDate,
    BInputPhone,
  },
  methods: { getErrorMessages },
  setup() {
    fillDirectory(['genders', 'workSchedules', 'workFormats'])

    return {
      ...useUserCardStore(),
      ...useUserCardGeneralStore(),
      emailMask,
      innMask,
    }
  },
}
</script>
